"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.taxComponentFromObj = exports.getTaxComponentName = exports.taxTypeNames = exports.eTaxType = exports.defaultTaxNames = void 0;
const flatTax_1 = __importDefault(require("./flatTax"));
const premiumAndFeesTax_1 = __importDefault(require("./premiumAndFeesTax"));
const premiumOnlyTax_1 = __importDefault(require("./premiumOnlyTax"));
const taxes_class_1 = __importDefault(require("./taxes.class"));
exports.defaultTaxNames = {
    SURPLUS_LINES_TAX: "Surplus Lines Tax",
    STAMPING_FEE: "Stamping Fee"
};
var eTaxType;
(function (eTaxType) {
    eTaxType["PREMIUM_AND_FEES"] = "PREMIUM_AND_FEES";
    eTaxType["PREMIUM_ONLY"] = "PREMIUM_ONLY";
    eTaxType["FLAT_TAX"] = "FLAT_TAX";
})(eTaxType = exports.eTaxType || (exports.eTaxType = {}));
exports.taxTypeNames = {
    [eTaxType.PREMIUM_AND_FEES]: "Premium & Fees",
    [eTaxType.PREMIUM_ONLY]: "Premium Only",
    [eTaxType.FLAT_TAX]: "Flat Tax"
};
const getTaxComponentName = (data) => {
    if (data.name) {
        return data.name;
    }
    if (data.type === "stampingFee") {
        return exports.defaultTaxNames.STAMPING_FEE;
    }
    return exports.defaultTaxNames.SURPLUS_LINES_TAX;
};
exports.getTaxComponentName = getTaxComponentName;
const taxComponentFromObj = (data) => {
    if (data.type === eTaxType.FLAT_TAX || data.appliesTo === "flatFee") {
        return flatTax_1.default.fromObj(data);
    }
    if (data.type === eTaxType.PREMIUM_AND_FEES ||
        data.appliesTo === "premiumAndFees") {
        return premiumAndFeesTax_1.default.fromObj(data);
    }
    return premiumOnlyTax_1.default.fromObj(data);
};
exports.taxComponentFromObj = taxComponentFromObj;
exports.default = taxes_class_1.default;
//# sourceMappingURL=index.js.map